import { render, staticRenderFns } from "./DiyoboEvent.vue?vue&type=template&id=d057614c&scoped=true&"
import script from "./DiyoboEvent.vue?vue&type=script&lang=js&"
export * from "./DiyoboEvent.vue?vue&type=script&lang=js&"
import style0 from "./DiyoboEvent.vue?vue&type=style&index=0&id=d057614c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d057614c",
  null
  
)

export default component.exports